import { render, staticRenderFns } from "./member-search.vue?vue&type=template&id=5c2239cb&lang=pug&"
import script from "./member-search.vue?vue&type=script&lang=js&"
export * from "./member-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports